import React, { PropsWithChildren } from 'react';
import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react';
import { Typography, Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import * as ErrorFallback from 'components/ErrorFallback';
import { FallbackProps } from 'components/ErrorFallback/types';

function Fallback({ resetError, eventId }: FallbackProps) {
  const { t } = useTranslation('Sentry');

  return (
    <ErrorFallback.Container>
      <ErrorFallback.Title title={t('genericErrorBoundary.title1')} />
      <Box padding="0 1rem">
        <Typography paragraph>{t('cartErrorBoundary.subtitle')}</Typography>
      </Box>
      <ErrorFallback.Actions resetError={resetError} eventId={eventId} />
    </ErrorFallback.Container>
  );
}

function ErrorBoundary({ children }: PropsWithChildren<{}>) {
  return (
    <SentryErrorBoundary
      beforeCapture={scope => {
        scope.setTag('component', 'cart');
      }}
      fallback={({ resetError, eventId }) => (
        <Fallback resetError={resetError} eventId={eventId} />
      )}
    >
      {children}
    </SentryErrorBoundary>
  );
}

export default ErrorBoundary;
